<template>
  <InputSelect
    :error-fields="errorFields"
    :model-value="modelValue"
    :name="name"
    :options="companies"
    :submitted="submitted"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    Partecipante
  </InputSelect>
</template>

<script setup>
import useAxios from "@/composables/axios";

import InputSelect from './InputSelect.vue';

const props = defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    default: null
  },
  companyUuid: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue'])

const axios = useAxios()

const companyResp = await axios.get('/company/list')
const companies = companyResp.data.map((company) => {
  return {
    id: company.uuid,
    label: company.name
  }
})

</script>